import { render, staticRenderFns } from "./TicketEditor.vue?vue&type=template&id=4e75a165&"
import script from "./TicketEditor.vue?vue&type=script&lang=js&"
export * from "./TicketEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports